import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Card, Col, Collapse, Form, Row, Spin } from "antd";

const antIcon = <Loading3QuartersOutlined spin />;
interface PropsType {
  onClose: () => void;
  title: string;
  heading: string;
  paragraph?: string | JSX.Element;
  btnText: string;
  btnApi: () => void;
  loading: boolean;
  secondBtnText?: string;
  isArchivePopup?: boolean;
}

const ServeLinePriorityPopup = (props: PropsType) => {
  const { loading } = props;

  const listItems = [
    "Contract renewal alerts",
    "Automatically mark idle potential deals as lost",
    "Automatic proposal follow-ups",
    "Upcoming visit reminders",
  ];
  const text: JSX.Element = (
    <ul style={{ textAlign: "left", paddingLeft: 20, margin: 0 }}>
      {listItems.map((item, idx) => (
        <li key={idx}>{item}</li>
      ))}
    </ul>
  );

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <Form layout="vertical" autoComplete="off" name="dependencies">
        <div
          className="modalWrapper addContactModal"
          style={{
            alignItems: "center",
            gap: "8px",
            paddingTop: "24px",
            paddingBottom: "24px",
          }}
        >
          <div className="modal_header">
            <div className="title">
              <h2 style={{ marginBottom: "0px" }}>
                Service line settings priority
              </h2>
            </div>
          </div>

          <div className="modal_content">
            <Row gutter={16}>
              <Col span={24} style={{ textAlign: "center" }}>
                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    marginBottom: "32px",
                  }}
                >
                  This order decides which service line settings to use when a
                  contract has multiple service lines with different workflows
                  and none are set for the property or client.
                </p>

                <Collapse
                  size="small"
                  items={[
                    {
                      key: "1",
                      label: "View settings affected.",
                      children: <p>{text}</p>,
                    },
                  ]}
                  className="priority_collapse_menu"
                />

                <Card className="priority_draggable_list">
                  <ul>
                    <li>
                      <span className="num_value">1</span> Landscape maintenance
                    </li>
                    <li>
                      <span className="num_value">2</span> Enhancements
                    </li>
                    <li>
                      <span className="num_value">3</span> Irrigation
                    </li>
                    <li>
                      <span className="num_value">4</span> Lawn care
                    </li>
                    <li>
                      <span className="num_value">5</span> Snow services
                    </li>
                  </ul>
                </Card>
              </Col>
            </Row>
          </div>

          <div className="modal_footer" style={{ justifyContent: "flex-end" }}>
            <Button
              htmlType="button"
              type="default"
              size="large"
              className="outlined-btn"
            >
              Back
            </Button>

            <Button
              htmlType="submit"
              type="primary"
              size="large"
              className="mint-btn"
            >
              Save changes
            </Button>
          </div>
        </div>
      </Form>
    </Spin>
  );
};

export default ServeLinePriorityPopup;
